import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import NotFound from "./NotFound";
import {fetchAllCourses, fetchCourseInfo} from "../services/MentorApiService";

const CourseRouteGuard = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [isValid, setIsValid] = useState<boolean | null>(null);

    const checkConversation = () => {
        if (id != null) {
            fetchCourseInfo(parseInt(id, 10))
                .then((response) => {
                    if(response.data.count === 0){
                        navigate(`/courses/${id}/form`, {replace: true});
                    }else{
                        navigate(`/courses/${id}/chat`, {replace: true});
                    }
                    setIsValid(true);
                })
                .catch((error) => {
                    setIsValid(false);
                });
        }else{
            setIsValid(false);
        }
    }

    useEffect(() => {
        checkConversation();
    }, [id, navigate]);

    if (isValid === null) {
        return <div>Loading...</div>;
    }

    return isValid ? null : <NotFound />;
};

export default CourseRouteGuard;